export default "/images/vendor/flag-icon-css/flags/4x3/gw.svg?f29eedfe431a60cae11edef68d978860";